import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function registerStudent(payload) {
  const response = await apiClient.post("/api/v1/onboarding/students/", payload);
  return response.data;
}

function useRegisterStudent() {
  return useMutation({ mutationFn: registerStudent });
}

export { useRegisterStudent };
